import React from 'react';
import { moeda } from '../util/util';
import { ehInternacional, textoOrigem } from './moedaOrigemPolicy';

/**
 * Valor financeiro com a moeda de origem (item 15, 27/09). Padrão fin-pp:
 *   R$ 5.100,00
 *   US$ 1.000,00 · câmbio 5,10        ← só quando a origem é internacional
 *
 * Nacional/legado (origem null): renderiza EXATAMENTE o texto de hoje ("R$ " + moeda(valor),
 * ou só moeda(valor) com semPrefixo) — sem wrapper extra, para a tela não mudar.
 *
 * Props: valor (R$), origem (API: origem_moeda | somarOrigens()), semPrefixo, inline (origem na
 * mesma linha, para células estreitas/strings), className (aplicado só ao bloco da origem).
 */
export default function ValorComOrigem({ valor, origem, semPrefixo = false, inline = false, className = '' }) {
    const principal = semPrefixo ? moeda(valor) : `R$ ${moeda(valor)}`;
    if (!ehInternacional(origem)) return <>{principal}</>;
    const texto = textoOrigem(origem);
    const titulo = textoOrigem(origem, true);
    return (
        <>
            {principal}
            <span className={`fin-pp__origem${inline ? ' is-inline' : ''}${className ? ' ' + className : ''}`} title={titulo} data-origem-moeda="1">
                {texto}
            </span>
        </>
    );
}

/** Só a linha de origem (quando o R$ já está renderizado ao lado). comBrl: inclui "→ R$" (sem R$ ao lado). */
export function OrigemMoeda({ origem, inline = false, className = '', comBrl = false }) {
    if (!ehInternacional(origem)) return null;
    return (
        <span className={`fin-pp__origem${inline ? ' is-inline' : ''}${className ? ' ' + className : ''}`} title={textoOrigem(origem, true)} data-origem-moeda="1">
            {textoOrigem(origem, comBrl)}
        </span>
    );
}
